import { UserActionName } from '../../../user-action';
import { navigationActivityHandler } from '../navigation-activity-handler';
import { map } from 'rxjs/operators';
import { DetailedActivityData, ActivityStudyDetail } from '../../../activity-data';
import { findProtocolId } from '../../../../shared/route-helpers';

export const sponsorDefaultActivityHandler = (userAction: UserActionName) => {
    return navigationActivityHandler(
        ({ route, activitySession }) => {
            const protocolId = findProtocolId(route);

            return activitySession.pipe(
                map(session => new DetailedActivityData(
                    userAction,
                    session.userSessionId,
                    [
                        new ActivityStudyDetail(
                            protocolId,
                        )
                    ]
                ))
            );
        }
    );
};